var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRoleCompany48Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A21C454A-95F1-4B64-A236-4519EB4EF90F_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,24 C48,37.2548348 37.2548348,48 24,48 C10.7451652,48 0,37.2548348 0,24 C0,10.7451652 10.7451652,0 24,0 C37.2548348,0 48,10.7451652 48,24 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Overlay---Rollivahetus",
    transform: "translate(-50.000000, -242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-12",
    transform: "translate(34.000000, 226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Role-Company_48px",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke-3-+-Stroke-5-Mask"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFCD00",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    mask: "url(#mask-2)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3157895,3.36842105 L30.3157895,33.6842105 C30.3157895,36.4631579 28.0421053,38.7368421 25.2631579,38.7368421 L6.73684211,38.7368421 C3.95789474,38.7368421 1.68421053,36.4631579 1.68421053,33.6842105 L1.68421053,3.36842105",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-3",
    points: "14.3157895 10.4210526 17.6842105 10.4210526 17.6842105 17.4210526 14.3157895 17.4210526"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-7",
    points: "6.73684211 10.4210526 10.1052632 10.4210526 10.1052632 17.4210526 6.73684211 17.4210526"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-9",
    points: "21.8947368 10.4210526 25.2631579 10.4210526 25.2631579 17.4210526 21.8947368 17.4210526"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-15",
    points: "12.6315789 36.7368421 12.6315789 25 19.3684211 25 19.3684211 36.7368421"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-17",
    points: "0 0 32 0 32 3.36842105 0 3.36842105"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoleCompany48Px);
export default __webpack_public_path__ + "static/media/Icon_Role-Company_48px.78d33b416e4b498362b77207f8b347c8.svg";
export { ForwardRef as ReactComponent };